(() => {
  function parseGlowJson(wrapper) {
    const el = wrapper.querySelector('[data-umbra-glow-json]');
    if (!el) return null;
    try { return JSON.parse(el.textContent.trim()); } catch (e) { return null; }
  }

  function getMainGalleryRoot(wrapper) {
    // Ajusta el root lo más cerca posible de la galería principal
    return (
      wrapper.closest('.product-media-gallery') ||
      wrapper.closest('[data-product-media-gallery]') ||
      wrapper.closest('.product__media') ||
      wrapper.parentElement
    );
  }

  function isThumbnailImg(img) {
    // Evita tocar miniaturas / thumbs
    const thumb = img.closest(
      '.product-media-gallery__thumbnails,' +
      '.media-thumbnails,' +
      '.thumbnails,' +
      '.thumbnail,' +
      '[data-thumbnails]'
    );
    return !!thumb;
  }

  function getMainImages(galleryRoot) {
    // Tomamos imágenes dentro del "main" / viewport / slider, excluyendo thumbs
    const candidates = Array.from(galleryRoot.querySelectorAll('img'))
      .filter(img => !isThumbnailImg(img));

    // Filtrado extra: muchas miniaturas usan width/height muy pequeños o loading eager/attrs raros.
    // Nos quedamos con las que están dentro de un contenedor de media/slide, si existe.
    const refined = candidates.filter(img => {
      return img.closest('.swiper-wrapper, .splide__track, .media-gallery, .product-media-gallery__main, [data-media], [data-product-media]') || true;
    });

    // Quita duplicados por referencia
    return Array.from(new Set(refined));
  }

  function stashOriginal(img) {
    if (!img.dataset.umbraOriginalSrc) {
      img.dataset.umbraOriginalSrc = img.currentSrc || img.src || '';
      img.dataset.umbraOriginalSrcset = img.getAttribute('srcset') || '';
    }
  }

  function setGlow(img, glowItem) {
    if (!img || !glowItem) return;
    stashOriginal(img);

    const url = glowItem.url1200 || glowItem.url800 || glowItem.url;
    if (!url) return;

    img.src = url;
    img.removeAttribute('srcset'); // fuerza glow
  }

  function restore(img) {
    const orig = img?.dataset?.umbraOriginalSrc;
    if (!orig) return;

    img.src = orig;

    const srcset = img.dataset.umbraOriginalSrcset;
    if (srcset) img.setAttribute('srcset', srcset);
  }

  function applyGlowToAll(galleryRoot, glowData) {
    const imgs = getMainImages(galleryRoot);

    // Mapeo por índice: imagen 0 -> glow 0, etc.
    imgs.forEach((img, idx) => {
      const glowItem = glowData[idx] || glowData[0]; // fallback a la primera si faltan
      setGlow(img, glowItem);
    });
  }

  function restoreAll(galleryRoot) {
    const imgs = getMainImages(galleryRoot);
    imgs.forEach(restore);
  }

  function initGlowToggle(wrapper) {
    const btn = wrapper.querySelector('[data-umbra-glow-btn]');
    const glowData = parseGlowJson(wrapper);
    if (!btn || !glowData || !glowData.length) return;

    const galleryRoot = getMainGalleryRoot(wrapper);
    let isGlow = false;

    btn.addEventListener('click', () => {
      isGlow = !isGlow;
      btn.setAttribute('aria-pressed', String(isGlow));
      btn.classList.toggle('is-on', isGlow);

      if (isGlow) {
        applyGlowToAll(galleryRoot, glowData);
      } else {
        restoreAll(galleryRoot);
      }
    });

    // Si el slider cambia y estamos en glow, aseguramos que la nueva slide siga en glow.
    // (En muchos temas esto ya no es necesario si cambiamos todas, pero lo dejamos por robustez)
    const obs = new MutationObserver(() => {
      if (isGlow) applyGlowToAll(galleryRoot, glowData);
    });

    obs.observe(galleryRoot, { subtree: true, attributes: true, attributeFilter: ['class', 'aria-current', 'style'] });
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-umbra-glow]').forEach(initGlowToggle);
  });

  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll?.('[data-umbra-glow]')?.forEach(initGlowToggle);
  });
})();
